import { render, staticRenderFns } from "./CustomFieldDialog.vue?vue&type=template&id=81d8ceb6&scoped=true&"
import script from "./CustomFieldDialog.vue?vue&type=script&lang=js&"
export * from "./CustomFieldDialog.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldDialog.vue?vue&type=style&index=0&id=81d8ceb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d8ceb6",
  null
  
)

export default component.exports